import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { DataService } from "src/app/@core/services/data.service";
import {
  OpenseaInterface,
} from "src/app/@core/models/site-data.model";
import * as Sentry from "@sentry/browser";
import { OpenseaService } from "src/app/@core/services/opensea.service";
import { IAssetsOpensea } from "src/app/@core/models/opensea-model";
import { isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-e-opensea",
  templateUrl: "./opensea.component.html",
  styleUrls: ["./opensea.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialOpenseaComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  errorMessage: string;
  data: OpenseaInterface;
  active: boolean = false;
  editOn: boolean = false;
  loading: boolean = false;
  classBuilder: string = "";
  backgroundColor: string = "";
  position: number = 0;
  style: string = "";
  activatePadding: boolean = false;
  maxWidth: string = "1500";
  siteId: string = "";
  nbrProductsPerLine: number = 3;
  currency: string = "";
  title: string = "";
  titleSize: string = "";
  titleColor: string = "";
  timeOut;
  componentsNames: string = "";
  order_direction: string = "desc";
  collection: string = "doodles-official";
  order_by: string = "sale_price";
  optionSelected: string = "collection";
  asset: string = "";
  tokenId: string = "";
  offset: number = 0;
  limit: number = 20;
  assets$: BehaviorSubject<IAssetsOpensea[]> = new BehaviorSubject<
    IAssetsOpensea[]
  >(null);

  constructor(
    @Inject(PLATFORM_ID) public platformId,
    private dataService: DataService,
    private openseaService: OpenseaService
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.title = this.data.title;
      this.order_direction = this.data.order_direction;
      this.optionSelected = this.data.optionSelected;
      this.collection = this.data.collection;
      this.asset = this.data.asset;
      this.tokenId = this.data.tokenId;
      this.limit = this.data.limit;
      this.order_by = this.data.order_by;
      this.backgroundColor = this.data.backgroundColor;
      this.nbrProductsPerLine = this.data.nbrProductsPerLine
        ? this.data.nbrProductsPerLine
        : 3;
      this.titleColor = this.data.titleColor ? this.data.titleColor : this.dataService.getDefaultColor(this.backgroundColor);
      this.subscription = this.dataService.getSiteId().subscribe((siteId) => {
        if (siteId) {
          this.siteId = siteId;
        }
      });
      if (this.optionSelected == "collection") {
        this.subscription = this.openseaService
          .getAssets(
            this.order_direction,
            this.collection,
            this.offset,
            this.limit
          )
          .subscribe((resp) => {
            this.assets$.next(resp.assets);
          });
        this.componentsNames = this.dataService
          .getComponentsNames("Ecommerce")
          .join(" ");
        Sentry.configureScope(function (scope) {
          scope.setTag("component", "OpenseaComponent");
        });
      } else {
        this.subscription = this.openseaService
          .getSingleAsset(this.asset, this.tokenId)
          .subscribe((resp) => {
            this.assets$.next([resp]);
          });
        this.componentsNames = this.dataService
          .getComponentsNames("Ecommerce")
          .join(" ");
        Sentry.configureScope(function (scope) {
          scope.setTag("component", "OpenseaComponent");
        });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
